import { render, staticRenderFns } from "./CompanyAccess.vue?vue&type=template&id=6c058b73"
import script from "./CompanyAccess.vue?vue&type=script&lang=js"
export * from "./CompanyAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports